module.exports = __webpack_public_path__ + "static/media/horse-playing-football.8fc90269.gif";